
export default function AppChat() {
    
}